// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.inner-content {
  background-color: #FFF7EC;
  min-height: 600px;
}

.inner-wrapper {
  overflow: auto;
  height: 100%;
}

::ng-deep .ng-clear-wrapper {
  width: 30px !important;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.help-wrapper {
  border-radius: 8px;
}
.help-wrapper .help-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px;
  padding-top: 60px;
}
.help-wrapper .help-header .help-header__title {
  font-weight: 500;
  font-size: 18px;
  font-family: "Roboto-Medium";
  color: #262627;
}
.help-wrapper .help-header .help-header__option {
  cursor: pointer;
  color: #A7A7AE;
}
.help-wrapper .help-header .help-header__option:hover {
  color: #88888d;
}
.help-wrapper .help-header .help-header__option ion-icon {
  font-size: 24px;
}
.help-wrapper .help-list {
  padding-bottom: 1rem;
}
.help-wrapper .help-list .help-block {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #DDDEE3;
  margin: 0 30px;
  height: 73px;
  align-items: center;
  cursor: pointer;
}
.help-wrapper .help-list .help-block .help-block__details .help-block__title {
  color: #262627;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin: 0.3rem;
  display: -webkit-box;
  max-width: 400px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.help-wrapper .help-list .help-block .help-block__details .help-block__date {
  font-weight: 400;
  font-size: 12px;
  color: #58585F;
}
.help-wrapper .help-list .help-block .help-block__arrow {
  cursor: pointer;
  color: #EB0000;
}

.back-button-block {
  margin: 0;
  padding: 30px;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  background-color: #FFF7EC;
  position: fixed;
  top: 0;
  z-index: 2005;
}
.back-button-block vl-icon {
  width: fit-content;
  padding: 0;
}
.back-button-block ion-button {
  position: initial;
  margin-left: 10px;
  margin-bottom: 0;
}

.searchbar-wrapper {
  margin: 23px 30px 23px;
  position: relative;
}

.no-items {
  max-height: 150px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0px 30px;
}
.no-items img {
  margin-bottom: 10px;
  height: 88px;
  opacity: 0.4;
  border-radius: 10px;
}
.no-items h6 {
  position: absolute;
  bottom: 43%;
  width: 83%;
  font-weight: 500;
  font-family: "Roboto-Medium";
  color: #A7A7AE;
}

.data-more {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 30px;
}
.data-more span {
  align-items: center;
  display: flex;
}
.data-more span ion-icon {
  padding-left: 5px;
}

.search-btn {
  right: 11px;
  top: 46%;
  text-align: center;
  margin: auto;
  transform: translateY(-50%);
  position: absolute;
  z-index: 2000;
  background: white;
}

.page-view {
  display: flex;
  flex-direction: row;
  max-height: 100%;
  overflow: hidden;
}
.page-view .data-more {
  padding-top: 25px;
}
.page-view .help-list {
  max-height: 685px;
  overflow-y: auto;
  border-right: 1px solid #DDDEE3;
}
.page-view .inner-content {
  min-width: 30%;
}
.page-view .page-details {
  min-width: 70%;
  height: 100%;
  min-height: 685px;
}
.page-view .help-header {
  padding-top: 0 !important;
}
.page-view .help-header .help-header__title {
  font-size: 1.75rem !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/shared/components/context-help/context-help-list/context-help-list.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAxDA;EACE,yBAAA;EACA,iBAAA;AA2DF;;AAzDA;EACE,cAAA;EACA,YAAA;AA4DF;;AAzDE;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA4DJ;;AAzDA;EACI,kBAAA;AA4DJ;AA1DI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AA4DN;AA1DM;EACE,gBAAA;EACA,eAAA;EACA,4BDzBQ;EC0BR,cAAA;AA4DR;AAzDM;EACE,eAAA;EACA,cAAA;AA2DR;AA1DQ;EACE,cAAA;AA4DV;AA1DQ;EACE,eAAA;AA4DV;AAvDI;EACI,oBAAA;AAyDR;AAxDM;EACE,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,cAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AAyDR;AAvDU;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAyDZ;AAtDU;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAwDZ;AApDQ;EACE,eAAA;EACA,cAAA;AAsDV;;AAhDA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;AAmDF;AAlDE;EACE,kBAAA;EACA,UAAA;AAoDJ;AAlDE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;AAoDJ;;AAhDA;EACE,sBAAA;EACA,kBAAA;AAmDF;;AAhDA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAiBA,iBAAA;AAmCF;AAlDE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAoDJ;AAjDE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,4BD9HY;EC+HZ,cAAA;AAmDJ;;AA5CA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AA+CF;AA9CE;EACE,mBAAA;EACA,aAAA;AAgDJ;AA/CI;EACE,iBAAA;AAiDN;;AA5CA;EACE,WAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AA+CF;;AA5CA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AA+CF;AA9CE;EACE,iBAAA;AAgDJ;AA9CE;EACE,iBAAA;EACA,gBAAA;EACA,+BAAA;AAgDJ;AA9CE;EACE,cAAA;AAgDJ;AA9CE;EACE,cAAA;EACA,YAAA;EACA,iBAAA;AAgDJ;AA9CE;EACE,yBAAA;AAgDJ;AA/CI;EACE,6BAAA;AAiDN","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n.inner-content {\n  background-color: #FFF7EC;\n  min-height: 600px;\n}\n.inner-wrapper {\n  overflow: auto;\n  height: 100%;\n}\n::ng-deep {\n  .ng-clear-wrapper {\n    width: 30px !important;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n.help-wrapper {\n    border-radius: 8px;\n  \n    .help-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin: 30px;\n      padding-top: 60px;\n  \n      .help-header__title {\n        font-weight: 500;\n        font-size: 18px;\n        font-family: $roboto-medium;\n        color: #262627;\n      }\n  \n      .help-header__option {\n        cursor: pointer;\n        color: #A7A7AE;\n        &:hover{\n          color: #88888d;\n        }\n        ion-icon {\n          font-size: 24px;\n        }\n      }\n    }\n  \n    .help-list {\n        padding-bottom: 1rem;\n      .help-block {\n        display: flex;\n        justify-content: space-between;\n        border-bottom: 1px solid #DDDEE3;\n        margin: 0 30px;\n        height: 73px;\n\n        align-items: center;\n        cursor: pointer;\n        .help-block__details {\n          .help-block__title {\n            color: #262627;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 19px;\n            margin: 0.3rem;\n            display: -webkit-box;\n            max-width: 400px;\n            -webkit-line-clamp: 3;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n  \n          .help-block__date {\n            font-weight: 400;\n            font-size: 12px;\n            color: #58585F;\n          }\n        }\n  \n        .help-block__arrow {\n          cursor: pointer;\n          color: #EB0000;\n        }\n      }\n    }\n}\n\n.back-button-block {\n  margin: 0;\n  padding: 30px;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  background-color: #FFF7EC;\n  position: fixed;\n  top: 0;\n  z-index: 2005;\n  vl-icon {\n    width: fit-content;\n    padding: 0;\n  }\n  ion-button {\n    position: initial;\n    margin-left: 10px;\n    margin-bottom: 0;\n  }\n}\n\n.searchbar-wrapper {\n  margin: 23px 30px 23px;\n  position: relative;\n}\n\n.no-items {\n  max-height: 150px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  img {\n    margin-bottom: 10px;\n    height: 88px;\n    opacity: 0.4;\n    border-radius: 10px;\n  }\n\n  h6 {\n    position: absolute;\n    bottom: 43%;\n    width: 83%;\n    font-weight: 500;\n    font-family: $roboto-medium;\n    color: #A7A7AE;\n  }\n  padding: 0px 30px;\n}\n\n\n\n.data-more {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 16px 30px;\n  span {\n    align-items: center;\n    display: flex;\n    ion-icon {\n      padding-left: 5px;\n    }\n  }\n}\n\n.search-btn {\n  right: 11px;\n  top: 46%;\n  text-align: center;\n  margin: auto;\n  transform: translateY(-50%);\n  position: absolute;\n  z-index: 2000;\n  background: white;\n}\n\n.page-view {\n  display: flex;\n  flex-direction: row;\n  max-height: 100%;\n  overflow: hidden;\n  .data-more {\n    padding-top: 25px;\n  }\n  .help-list {\n    max-height: 685px;\n    overflow-y: auto;\n    border-right: 1px solid #DDDEE3;\n  }\n  .inner-content {\n    min-width: 30%;\n  }\n  .page-details {\n    min-width: 70%;\n    height: 100%;\n    min-height: 685px;\n  }\n  .help-header {\n    padding-top: 0 !important;\n    .help-header__title {\n      font-size: 1.75rem !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
